// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';

class OverflowDecorator extends Component<any, any> {

    overflowStyle: any = {
        background: '#ef3434',
        color: '#fff'
    }

	render() {
		return (
            <span style={this.overflowStyle}>{this.props.children}</span>
		)
	}
}

export default OverflowDecorator;

